import { useState, useEffect } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../Firebase/firebaseConfig/firebase';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getProductoById } from './CRUD/Mostrar';
import { deleteProducto } from './CRUD/Mostrar';
import Swal from 'sweetalert2';
import { useAuth } from '../AuthContext';

export default function DetalleProducto() {

    const id = useParams().id;
    const [producto, setProducto] = useState([]);
    const [cantidad, setCantidad] = useState(1);
    const navigate = useNavigate();
		const { userId, setAuthUserId } = useAuth();

		useEffect(() => {
			// Hacer algo con el userId
			console.log('UserID:', userId);
		}, [userId]);
	
    async function getProducto(id) {
        setProducto((await getProductoById(id)).data())
    }
    useEffect(() => {
        getProducto(id);
    }, [id])

    const carritoCollection = collection(db, "Cart");
    const nuevo = async () => {
        await addDoc(carritoCollection, {UID: userId, Nombre: Nombre, Precio: Precio, Cantidad: cantidad });
        navigate("/carrito");
    }

    const {
				UID,
        Nombre,
        Imagen,
        Precio,
        Alcoholica,
        Contenido,
        Descripcion,
    } = producto;


    function agregarCantidad() {
        setCantidad((cantidad) => cantidad + 1);
    }
    function restarCantidad() {
        if (cantidad > 1) { setCantidad((cantidad) => cantidad - 1); }
    }

    function confirmDelete() {
        Swal.fire({
            title: "Vas a eliminar un producto",
            text: "¿Estas seguro?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, eliminar!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await deleteProducto(id);
                Swal.fire("Eliminado", "El producto fue eliminado.", "Listo");
                navigate("/productos");
            }
        });
    };

    return (

        <>
            <section class="container item my-auto bg-dark text-light mt-2">
                <picture>
                    <img class="item-img" src={Imagen} alt="imagen del producto" />
                </picture>
                <article class="item-info">
                    <div className='edit-button'>
                        <Link className='text-decoration-none producto-link' to={`/editar/producto/${id}`}>
                            <button class="btn btn-light mx-1 btn-sm" href=""><i class="fa-solid fa-pen-to-square"></i></button>
                        </Link>
                        <button onClick={confirmDelete} class="btn btn-danger mx-1 btn-sm" href=""><i class="fa-solid fa-trash "></i></button>
                    </div>
                    <h3 class="item-nombre">{Nombre}</h3>
                    <p class="item-subtitulo"><b>{Alcoholica ? 'Alcohólica' : 'No alcohólica'}</b> ({Contenido})</p>
                    <p class="item-descripcion">{Descripcion}</p>
                    <p class="item-precio">${Precio},00</p>
                    <div class="item-carrito">
                        <button onClick={restarCantidad} class="item-cantidad producto-btn" type="button">-</button>
                        <input id='cantidad' class="item-input" type="text" name="cantidad" disabled value={cantidad} />
                        <button onClick={agregarCantidad} class="item-cantidad producto-btn" type="button">+</button>
                        <button onClick={nuevo} class="item-submit btn btn-primary btn-medium producto-btn" type="submit">Agregar al carrito</button>
                    </div>
                    <p class="item-envio"><i class="bi bi-truck"></i> Envio gratis</p>

                </article>
            </section>
        </>
    )
}